import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import { Checkbox } from "@repo/ui/Checkbox/checkbox";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import type { FC } from "react";
import { Can } from "../../../../helpers/teammateAuthorizationContext.js";

interface ChapterGradingResultsEmailSettingProps {
  isEnabled: boolean;
  onSave: (isEnabled: boolean) => void;
}

export const ChapterGradingResultsEmailSetting: FC<
  ChapterGradingResultsEmailSettingProps
> = ({ isEnabled, onSave }) => {
  return (
    <Can
      I={PermissionActions.UPDATE}
      a={PermissionSubjects.JOB_OPENINGS}
      passThrough={true}
    >
      {(allowed) => (
        <div className="space-y-2">
          <Label size={Size.SMALL} className="block">
            Playbook grades email
          </Label>
          <Checkbox
            isChecked={isEnabled}
            onChange={onSave}
            label="Email participants their playbook grades after each chapter is completed."
            isDisabled={!allowed}
          />
          <p className="text-sm text-muted-foreground">
            Results are sent again if a participant retakes and completes a
            chapter.
          </p>
        </div>
      )}
    </Can>
  );
};
